// @ts-check

import { Controller } from "@hotwired/stimulus"
import VinculoMovimentacoesListagemController from "./vinculo_movimentacoes_listagem_controller";

export default class EstoqueProdutoMovimentacaoFormController extends Controller {
  static values = { "movimentacaoQtde": { type: Number }, "isSaida": { type: Boolean }, precisaoQuantidade: Number }
  static outlets = [ "vinculo-movimentacoes-listagem" ]

  /** @returns {number} */
  get getMovimentacaoQtdeValue() {
    // @ts-ignore
    return this.movimentacaoQtdeValue;
  }

  /** @returns {boolean} */
  get getIsSaidaValue() {
    // @ts-ignore
    return this.isSaidaValue;
  }

  /** @param {number} value */
  set setMovimentacaoQtdeValue(value) {
    // @ts-ignore
    this.movimentacaoQtdeValue = value;
  }

  /** @returns {number} */
  get getPrecisaoQuantidadeValue() {
    // @ts-ignore
    return this.precisaoQuantidadeValue;
  }

  /** @returns {VinculoMovimentacoesListagemController} */
  get getVinculoMovimentacoesListagemOutlet() {
    // @ts-ignore
    return this.vinculoMovimentacoesListagemOutlet;
  }
}
